// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\Api\CargoActivity\ApiCargoActivity.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { BerthReservation, BerthReservationData, BerthReservationOptions } from 'data/models/BerthReservation';
import { CargoActivityType, CargoActivityTypeData, CargoActivityTypeOptions } from 'data/models/CargoActivityType';
import { CargoCategory, CargoCategoryData, CargoCategoryOptions } from 'data/models/CargoCategory';
import { NullableMeasurement, NullableMeasurementData, NullableMeasurementOptions } from 'data/models/Measurement';
import { TradeRoute, TradeRouteData, TradeRouteOptions } from 'data/models/TradeRoute';

// CargoActivityData is the class that CargoActivity serializes to/from
export interface CargoActivityData {
    Id : number;
	
    ActivityType : CargoActivityTypeData | null;
    ActivityTypeId : number | null;
    CargoCategory : CargoCategoryData | null;
    CargoCategoryId : number | null;
    Reservation : BerthReservationData | null;
    ReservationId : number;
    TradeRoute : TradeRouteData | null;
    TradeRouteId : number | null;
	
    Quantity : NullableMeasurementData;
}

// CargoActivityOptions is the class which may be passed to the CargoActivity constructor to define optional initial data values
export interface CargoActivityOptions {
    Id : number;
	
    ActivityType? : CargoActivityTypeOptions | null;
    ActivityTypeId? : number | null;
    CargoCategory? : CargoCategoryOptions | null;
    CargoCategoryId? : number | null;
    Reservation? : BerthReservationOptions | null;
    ReservationId? : number;
    TradeRoute? : TradeRouteOptions | null;
    TradeRouteId? : number | null;
	
    Quantity? : NullableMeasurementOptions;
}

export class CargoActivity {
    public Id : DataSignal<number>;
	
    public ActivityType : DataSignal<CargoActivityType | null>;
    public ActivityTypeId : DataSignal<number | null>;
    public CargoCategory : DataSignal<CargoCategory | null>;
    public CargoCategoryId : DataSignal<number | null>;
    public Reservation : DataSignal<BerthReservation | null>;
    public ReservationId : DataSignal<number>;
    public TradeRoute : DataSignal<TradeRoute | null>;
    public TradeRouteId : DataSignal<number | null>;
	
    public Quantity : NullableMeasurement;

    constructor();
    constructor(data : CargoActivityOptions);
    constructor(data: CargoActivityOptions | null = null) {
        this.Id = jsonableObservable(S.value<number>(data && data.Id !== undefined ? data.Id : 0));
	    
        this.ActivityType = S.value<CargoActivityType | null>(null);
        this.ActivityTypeId = jsonableObservable(S.value<number | null>(data && data.ActivityTypeId !== undefined ? data.ActivityTypeId : null));
        this.CargoCategory = S.value<CargoCategory | null>(null);
        this.CargoCategoryId = jsonableObservable(S.value<number | null>(data && data.CargoCategoryId !== undefined ? data.CargoCategoryId : null));
        this.Reservation = S.value<BerthReservation | null>(null);
        this.ReservationId = jsonableObservable(S.value<number>(data && data.ReservationId !== undefined ? data.ReservationId : 0));
        this.TradeRoute = S.value<TradeRoute | null>(null);
        this.TradeRouteId = jsonableObservable(S.value<number | null>(data && data.TradeRouteId !== undefined ? data.TradeRouteId : null));
	    
        this.Quantity = data && data.Quantity !== undefined ? new NullableMeasurement(data.Quantity) : new NullableMeasurement();
    }

    static key(obj : CargoActivity) {
        return obj.Id();
    }
    
    static dataKey(obj : CargoActivityOptions) {
        return obj.Id;
    }

    static update(obj : CargoActivity, data : CargoActivityOptions) {
        S.freeze(() => {
            if (data.Id !== undefined) obj.Id(data.Id);
	        
            if (data.ActivityTypeId !== undefined) obj.ActivityTypeId(data.ActivityTypeId);
            if (data.CargoCategoryId !== undefined) obj.CargoCategoryId(data.CargoCategoryId);
            if (data.ReservationId !== undefined) obj.ReservationId(data.ReservationId);
            if (data.TradeRouteId !== undefined) obj.TradeRouteId(data.TradeRouteId);
	        
            if (data.Quantity !== undefined) NullableMeasurement.update(obj.Quantity, data.Quantity);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/CargoActivity.ts